import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const submitBulkInquiry = (data) =>
    api.post(ENDPOINTS.BULK_INQUIRY.SUBMIT, data);

export const acceptQuoteByToken = (data) =>
    api.post(ENDPOINTS.BULK_INQUIRY.ACCEPT_QUOTE, data);

export const listMyInquiries = (params) =>
    api.get(ENDPOINTS.BULK_INQUIRY.MY_LIST, { params });

export const getMyInquiryDetail = (inquiryNumber) =>
    api.get(ENDPOINTS.BULK_INQUIRY.MY_DETAIL(inquiryNumber));

export const sendCustomerMessage = (inquiryNumber, data) =>
    api.post(ENDPOINTS.BULK_INQUIRY.MY_DETAIL(inquiryNumber) + '/messages', data);

export const acceptInquiryQuote = (inquiryNumber) =>
    api.post(ENDPOINTS.BULK_INQUIRY.ACCEPT(inquiryNumber));
